// Devanagari lookups for the string names returned by the live Swiss Ephemeris
// Panchangam API (which returns romanised Sanskrit names). Falls back to the
// romanised name when a key is missing, so nothing ever renders blank.

export const TITHI = {
  Pratipada: "प्रतिपदा", Dwitiya: "द्वितीया", Tritiya: "तृतीया", Chaturthi: "चतुर्थी",
  Panchami: "पञ्चमी", Shashthi: "षष्ठी", Saptami: "सप्तमी", Ashtami: "अष्टमी",
  Navami: "नवमी", Dashami: "दशमी", Ekadashi: "एकादशी", Dwadashi: "द्वादशी",
  Trayodashi: "त्रयोदशी", Chaturdashi: "चतुर्दशी", Purnima: "पूर्णिमा", Amavasya: "अमावस्या",
};

export const NAKSHATRA = {
  Ashwini: "अश्विनी", Bharani: "भरणी", Krittika: "कृत्तिका", Rohini: "रोहिणी",
  Mrigashira: "मृगशिरा", Mrigashirsha: "मृगशिरा", Ardra: "आर्द्रा", Punarvasu: "पुनर्वसु",
  Pushya: "पुष्य", Ashlesha: "आश्लेषा", Magha: "मघा",
  "Purva Phalguni": "पूर्वाफाल्गुनी", "Poorva Phalguni": "पूर्वाफाल्गुनी", "Uttara Phalguni": "उत्तराफाल्गुनी",
  Hasta: "हस्त", Chitra: "चित्रा", Swati: "स्वाति", Swathi: "स्वाति", Vishakha: "विशाखा",
  Anuradha: "अनुराधा", Jyeshtha: "ज्येष्ठा", Jyeshta: "ज्येष्ठा", Mula: "मूल", Moola: "मूल",
  "Purva Ashadha": "पूर्वाषाढ़ा", "Poorva Ashadha": "पूर्वाषाढ़ा", "Uttara Ashadha": "उत्तराषाढ़ा",
  Shravana: "श्रवण", Dhanishta: "धनिष्ठा", Shatabhisha: "शतभिषा", Shatabhishak: "शतभिषा",
  "Purva Bhadrapada": "पूर्वाभाद्रपदा", "Poorva Bhadrapada": "पूर्वाभाद्रपदा", "Uttara Bhadrapada": "उत्तराभाद्रपदा", Revati: "रेवती",
};

export const NAK_DEVATA = {
  // Exact strings emitted by the backend → Devanagari
  "Ashvini Kumaras": "अश्विनीकुमार",
  "Yama": "यम",
  "Agni": "अग्नि",
  "Brahma (Prajapati)": "ब्रह्मा",
  "Soma (Moon)": "चन्द्र",
  "Rudra (Shiva)": "रुद्र",
  "Aditi": "अदिति",
  "Brihaspati": "बृहस्पति",
  "Sarpas (Nagas)": "सर्प",
  "Pitris": "पितृ",
  "Bhaga": "भगादित्य",
  "Aryaman": "अर्यमा",
  "Savitr (Surya)": "सूर्य",
  "Tvastar (Vishvakarma)": "विश्वकर्मा",
  "Vayu": "वायु",
  "Indra-Agni": "इन्द्राग्नि",
  "Mitra": "मित्र",
  "Indra": "इन्द्र",
  "Nirriti": "निर्ऋति",
  "Apah (Water)": "आपः",
  "Vishvedevas": "विश्वेदेव",
  "Vishnu": "विष्णु",
  "Vasus": "वसु",
  "Varuna": "वरुण",
  "Aja Ekapada": "अजैकपाद",
  "Ahir Budhnya": "अहिर्बुध्न्य",
  "Pushan": "पूषा",
  // Common aliases / earlier spellings (backward compatible)
  "Ashwini Kumaras": "अश्विनीकुमार", Ashwini: "अश्विनीकुमार", Ashvini: "अश्विनीकुमार",
  Brahma: "ब्रह्मा", Soma: "चन्द्र", Chandra: "चन्द्र", Rudra: "रुद्र", Guru: "बृहस्पति",
  Sarpa: "सर्प", Nagas: "सर्प", Naga: "सर्प", Pitru: "पितृ", Savitr: "सूर्य", Savita: "सूर्य",
  Surya: "सूर्य", Tvashtar: "विश्वकर्मा", Tvastar: "विश्वकर्मा", Vishwakarma: "विश्वकर्मा",
  IndraAgni: "इन्द्राग्नि", Apas: "आपः", Apah: "आपः", Jala: "आपः", Vishwedevas: "विश्वेदेव",
  Vasu: "वसु", Ajaikapada: "अजैकपाद", Ahirbudhnya: "अहिर्बुध्न्य",
};

export const YOGA = {
  Vishkambha: "विष्कम्भ", Priti: "प्रीति", Ayushman: "आयुष्मान्", Saubhagya: "सौभाग्य",
  Shobhana: "शोभन", Atiganda: "अतिगण्ड", Sukarma: "सुकर्मा", Sukarman: "सुकर्मा", Dhriti: "धृति",
  Shula: "शूल", Ganda: "गण्ड", Vriddhi: "वृद्धि", Dhruva: "ध्रुव", Vyaghata: "व्याघात",
  Harshana: "हर्षण", Vajra: "वज्र", Siddhi: "सिद्धि", Vyatipata: "व्यतीपात",
  Variyana: "वरीयान्", Variyan: "वरीयान्", Parigha: "परिघ", Shiva: "शिव", Siddha: "सिद्ध",
  Sadhya: "साध्य", Shubha: "शुभ", Shukla: "शुक्ल", Brahma: "ब्रह्म", Indra: "ऐन्द्र",
  Aindra: "ऐन्द्र", Vaidhriti: "वैधृति",
};

export const KARANA = {
  Bava: "बव", Balava: "बालव", Kaulava: "कौलव", Taitila: "तैतिल", Gara: "गर", Garaja: "गर",
  Vanija: "वणिज", Vishti: "विष्टि", Bhadra: "विष्टि", Shakuni: "शकुनि", Sakuni: "शकुनि",
  Chatushpada: "चतुष्पाद", Chatushpad: "चतुष्पाद", Naga: "नाग", Kimstughna: "किंस्तुघ्न", Kintughna: "किंस्तुघ्न",
};

export const RASHI = {
  Mesha: "मेष", Vrishabha: "वृषभ", Vrisha: "वृषभ", Mithuna: "मिथुन", Karka: "कर्क", Kark: "कर्क",
  Simha: "सिंह", Kanya: "कन्या", Tula: "तुला", Vrishchika: "वृश्चिक", Vrischika: "वृश्चिक",
  Dhanu: "धनु", Dhanus: "धनु", Makara: "मकर", Makar: "मकर", Kumbha: "कुम्भ", Meena: "मीन", Mina: "मीन",
};

export const VARA = {
  Ravivara: "रविवार", Somavara: "सोमवार", Mangalavara: "मंगलवार", Budhavara: "बुधवार",
  Guruvara: "गुरुवार", Brihaspativara: "गुरुवार", Shukravara: "शुक्रवार", Shanivara: "शनिवार",
};

export const PAKSHA = { Shukla: "शुक्ल", Krishna: "कृष्ण" };

// Presiding devata of each weekday (vara).
export const VARA_DEVATA = {
  Ravivara: { en: "Surya", deva: "सूर्य" },
  Somavara: { en: "Shiva", deva: "शिव" },
  Mangalavara: { en: "Hanuman", deva: "हनुमान" },
  Budhavara: { en: "Vishnu", deva: "विष्णु" },
  Guruvara: { en: "Brihaspati", deva: "बृहस्पति" },
  Brihaspativara: { en: "Brihaspati", deva: "बृहस्पति" },
  Shukravara: { en: "Lakshmi", deva: "लक्ष्मी" },
  Shanivara: { en: "Shani", deva: "शनि" },
};

// Presiding devata of each tithi (classical associations).
export const TITHI_DEVATA = {
  Pratipada: { en: "Agni", deva: "अग्नि" },
  Dwitiya: { en: "Brahma", deva: "ब्रह्मा" },
  Tritiya: { en: "Gauri", deva: "गौरी" },
  Chaturthi: { en: "Ganesha", deva: "गणेश" },
  Panchami: { en: "Naga", deva: "नाग" },
  Shashthi: { en: "Kartikeya", deva: "कार्तिकेय" },
  Saptami: { en: "Surya", deva: "सूर्य" },
  Ashtami: { en: "Shiva", deva: "शिव" },
  Navami: { en: "Durga", deva: "दुर्गा" },
  Dashami: { en: "Yama", deva: "यम" },
  Ekadashi: { en: "Vishvedeva", deva: "विश्वेदेव" },
  Dwadashi: { en: "Vishnu", deva: "विष्णु" },
  Trayodashi: { en: "Kamadeva", deva: "कामदेव" },
  Chaturdashi: { en: "Shiva", deva: "शिव" },
  Purnima: { en: "Chandra", deva: "चन्द्र" },
  Amavasya: { en: "Pitru", deva: "पितृ" },
};

// Hora (planetary hour) auspiciousness + a short descriptor, keyed by the
// English planet name the API returns.
export const HORA_QUALITY = {
  Jupiter: "good", Venus: "good", Mercury: "good", Moon: "good",
  Sun: "caution", Mars: "caution", Saturn: "caution",
};

export const HORA_NOTE = {
  Sun: "Authority, health, government",
  Moon: "Travel, emotions, water, home",
  Mars: "Energy, courage, disputes",
  Mercury: "Learning, trade, communication",
  Jupiter: "Wisdom, ceremonies, wealth",
  Venus: "Arts, love, prosperity",
  Saturn: "Labour, discipline, delays",
};
